export default __webpack_public_path__ + "static/media/our-city-20.4fc0dfb9.png";